import React, { useState } from 'react';
import { DownloadIcon, PrinterIcon, CheckCircleIcon, ShieldCheckIcon, ArrowLeftIcon, QrCodeIcon } from 'lucide-react';
import { ownerData } from '../data/sampleData';
import { Modal } from '../components/Modal';
interface CertificatePageProps {
  navigate: (page: string) => void;
  t: (key: string) => string;
  lands: any[];
}
export function CertificatePage({
  navigate,
  t,
  lands
}: CertificatePageProps) {
  const [isQrModalOpen, setIsQrModalOpen] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const handleDownload = () => {
    setIsDownloading(true);
    setTimeout(() => {
      setIsDownloading(false);
      alert('Certificate PDF downloaded successfully.');
    }, 1500);
  };
  return <div className="max-w-4xl mx-auto space-y-6 pb-20 lg:pb-6" data-id="element-146">
      <div className="flex items-center justify-between" data-id="element-147">
        <button onClick={() => navigate('dashboard')} className="flex items-center gap-2 text-slate-500 hover:text-slate-800 transition-colors" data-id="element-148">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-149" /> {t('common.back')}
        </button>
        <div className="flex gap-2 sm:gap-3" data-id="element-150">
          <button onClick={() => window.print()} className="bg-white border border-slate-200 text-slate-700 hover:bg-slate-50 px-3 sm:px-4 py-2 rounded-lg font-medium text-sm transition-colors shadow-sm flex items-center gap-2" data-id="element-151">
            <PrinterIcon className="w-4 h-4" data-id="element-152" />{' '}
            <span className="hidden sm:inline" data-id="element-153">{t('common.print')}</span>
          </button>
          <button onClick={handleDownload} disabled={isDownloading} className="bg-[#006A4E] text-white hover:bg-[#00523c] px-3 sm:px-4 py-2 rounded-lg font-medium text-sm transition-colors shadow-sm flex items-center gap-2 disabled:opacity-70" data-id="element-154">
            <DownloadIcon className="w-4 h-4" data-id="element-155" />{' '}
            <span className="hidden sm:inline" data-id="element-156">
              {isDownloading ? 'Downloading...' : t('common.download')}
            </span>
          </button>
        </div>
      </div>

      {/* Certificate Document */}
      <div className="bg-white p-6 sm:p-8 md:p-12 rounded-xl shadow-lg border-4 sm:border-8 border-[#D4A843]/20 relative overflow-hidden print:shadow-none print:border-4" data-id="element-157">
        {/* Watermark */}
        <div className="absolute inset-0 flex items-center justify-center opacity-[0.03] pointer-events-none" data-id="element-158">
          <ShieldCheckIcon className="w-64 h-64 sm:w-96 sm:h-96" data-id="element-159" />
        </div>

        {/* Header */}
        <div className="text-center border-b-2 border-[#D4A843]/30 pb-6 mb-8 relative z-10" data-id="element-160">
          <div className="w-12 h-12 sm:w-16 sm:h-16 bg-[#006A4E] rounded-full mx-auto mb-4 flex items-center justify-center shadow-inner" data-id="element-161">
            <ShieldCheckIcon className="w-6 h-6 sm:w-8 sm:h-8 text-[#D4A843]" data-id="element-162" />
          </div>
          <h1 className="text-lg sm:text-2xl font-bold text-[#006A4E] uppercase tracking-wider" data-id="element-163">
            Government of the People's Republic of Bangladesh
          </h1>
          <h2 className="text-base sm:text-xl font-bold text-slate-800 mt-2" data-id="element-164">
            {t('certificate.title')}
          </h2>
          <p className="text-xs sm:text-sm text-slate-500 mt-1" data-id="element-165">
            Unified Land Management System
          </p>
        </div>

        {/* Top Meta */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-8 text-xs sm:text-sm font-mono relative z-10" data-id="element-166">
          <div data-id="element-167">
            <p data-id="element-168">
              <span className="text-slate-500" data-id="element-169">{t('certificate.certNo')}:</span>{' '}
              <span className="font-bold text-slate-800" data-id="element-170">
                {ownerData.certificateNo}
              </span>
            </p>
            <p data-id="element-171">
              <span className="text-slate-500" data-id="element-172">Issue Date:</span>{' '}
              <span className="font-bold text-slate-800" data-id="element-173">
                {ownerData.issueDate}
              </span>
            </p>
          </div>
          <div className="sm:text-right" data-id="element-174">
            <div className="inline-flex items-center gap-1 bg-green-50 text-green-700 px-3 py-1 rounded-full border border-green-200 font-sans font-semibold mb-2" data-id="element-175">
              <CheckCircleIcon className="w-4 h-4" data-id="element-176" /> {ownerData.validity}
            </div>
            <p data-id="element-177">
              <span className="text-slate-500" data-id="element-178">
                {t('certificate.ownerId')}:
              </span>{' '}
              <span className="font-bold text-slate-800" data-id="element-179">
                {ownerData.landOwnerId}
              </span>
            </p>
          </div>
        </div>

        {/* Main Info Grid */}
        <div className="flex flex-col md:flex-row gap-8 mb-10 relative z-10" data-id="element-180">
          <div className="flex-1 grid grid-cols-1 sm:grid-cols-2 gap-y-6 gap-x-8" data-id="element-181">
            <div className="sm:col-span-2" data-id="element-182">
              <p className="text-xs text-slate-500 uppercase tracking-wider mb-1" data-id="element-183">
                {t('certificate.ownerName')}
              </p>
              <p className="text-lg sm:text-xl font-bold text-slate-900 border-b border-slate-200 pb-1" data-id="element-184">
                {ownerData.name}
              </p>
            </div>
            <div data-id="element-185">
              <p className="text-xs text-slate-500 uppercase tracking-wider mb-1" data-id="element-186">
                National ID
              </p>
              <p className="font-medium text-slate-800" data-id="element-187">{ownerData.nid}</p>
            </div>
            <div data-id="element-188">
              <p className="text-xs text-slate-500 uppercase tracking-wider mb-1" data-id="element-189">
                Mobile Number
              </p>
              <p className="font-medium text-slate-800" data-id="element-190">{ownerData.mobile}</p>
            </div>
            <div data-id="element-191">
              <p className="text-xs text-slate-500 uppercase tracking-wider mb-1" data-id="element-192">
                Father's Name
              </p>
              <p className="font-medium text-slate-800" data-id="element-193">{ownerData.father}</p>
            </div>
            <div data-id="element-194">
              <p className="text-xs text-slate-500 uppercase tracking-wider mb-1" data-id="element-195">
                Mother's Name
              </p>
              <p className="font-medium text-slate-800" data-id="element-196">{ownerData.mother}</p>
            </div>
            <div className="sm:col-span-2" data-id="element-197">
              <p className="text-xs text-slate-500 uppercase tracking-wider mb-1" data-id="element-198">
                Registered Address
              </p>
              <p className="font-medium text-slate-800" data-id="element-199">{ownerData.address}</p>
            </div>
          </div>

          <div className="flex flex-row md:flex-col items-center justify-center gap-6 shrink-0" data-id="element-200">
            <div className="w-24 h-24 sm:w-32 sm:h-32 bg-slate-100 border-2 border-slate-200 rounded-lg flex items-center justify-center overflow-hidden" data-id="element-201">
              <span className="text-3xl sm:text-4xl font-bold text-slate-300" data-id="element-202">
                MR
              </span>
            </div>
            <button onClick={() => setIsQrModalOpen(true)} className="w-20 h-20 sm:w-24 sm:h-24 bg-white border-2 border-slate-800 p-2 rounded flex items-center justify-center hover:bg-slate-50 transition-colors group relative" data-id="element-203">
              <QrCodeIcon className="w-full h-full text-slate-800" data-id="element-204" />
              <div className="absolute inset-0 bg-black/60 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity rounded" data-id="element-205">
                <span className="text-white text-[10px] sm:text-xs font-bold" data-id="element-206">
                  Verify
                </span>
              </div>
            </button>
          </div>
        </div>

        {/* Lands Summary Table */}
        <div className="mb-8 sm:mb-12 relative z-10" data-id="element-207">
          <h3 className="text-sm font-bold text-slate-800 uppercase tracking-wider mb-4 border-b-2 border-[#D4A843]/30 pb-2" data-id="element-208">
            Summary of Owned Lands
          </h3>
          <div className="overflow-x-auto" data-id="element-209">
            <table className="w-full text-xs sm:text-sm text-left min-w-[500px]" data-id="element-210">
              <thead className="bg-slate-50 text-slate-600 font-medium border-y border-slate-200" data-id="element-211">
                <tr data-id="element-212">
                  <th className="py-3 px-4" data-id="element-213">{t('land.district')}</th>
                  <th className="py-3 px-4" data-id="element-214">{t('land.mouza')}</th>
                  <th className="py-3 px-4" data-id="element-215">{t('land.khatian')}</th>
                  <th className="py-3 px-4" data-id="element-216">{t('land.dag')}</th>
                  <th className="py-3 px-4" data-id="element-217">{t('land.area')}</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100" data-id="element-218">
                {lands.map(land => <tr key={land.id} data-id="element-219">
                    <td className="py-3 px-4" data-id="element-220">{land.district}</td>
                    <td className="py-3 px-4" data-id="element-221">{land.mouza}</td>
                    <td className="py-3 px-4" data-id="element-222">{land.khatian}</td>
                    <td className="py-3 px-4" data-id="element-223">{land.plot}</td>
                    <td className="py-3 px-4" data-id="element-224">{land.area}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        {/* Signatures */}
        <div className="flex flex-col sm:flex-row justify-between items-center sm:items-end gap-8 mt-12 sm:mt-16 pt-8 border-t border-slate-200 relative z-10" data-id="element-225">
          <div className="text-center" data-id="element-226">
            <p className="text-sm font-bold text-slate-800" data-id="element-227">
              District Land Office, Gazipur
            </p>
            <p className="text-xs text-slate-500" data-id="element-228">Issuing Authority</p>
          </div>
          <div className="text-center" data-id="element-229">
            <div className="w-40 h-12 border-b border-slate-400 mb-2 flex items-end justify-center pb-1" data-id="element-230">
              <span className="font-signature text-2xl text-blue-900 opacity-80" data-id="element-231">
                Digitally Signed
              </span>
            </div>
            <p className="text-xs text-slate-500 uppercase tracking-wider" data-id="element-232">
              Authorized Signature
            </p>
          </div>
        </div>
      </div>

      {/* QR Verify Modal */}
      <Modal isOpen={isQrModalOpen} onClose={() => setIsQrModalOpen(false)} title="Certificate Verification" footer={<button onClick={() => setIsQrModalOpen(false)} className="bg-slate-800 text-white px-4 py-2 rounded-lg text-sm font-medium" data-id="element-234">
            Close
          </button>} data-id="element-233">
        <div className="text-center py-6" data-id="element-235">
          <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-236">
            <CheckCircleIcon className="w-10 h-10 text-green-600" data-id="element-237" />
          </div>
          <h3 className="text-2xl font-bold text-slate-900 mb-2" data-id="element-238">
            Certificate Valid
          </h3>
          <p className="text-slate-600 mb-6" data-id="element-239">
            This Land Owner Certificate is authentic and currently active in the
            national database.
          </p>

          <div className="bg-slate-50 rounded-lg p-4 text-left border border-slate-200" data-id="element-240">
            <div className="grid grid-cols-2 gap-4 text-sm" data-id="element-241">
              <div data-id="element-242">
                <p className="text-slate-500 mb-1" data-id="element-243">
                  {t('certificate.ownerName')}
                </p>
                <p className="font-semibold text-slate-900" data-id="element-244">{ownerData.name}</p>
              </div>
              <div data-id="element-245">
                <p className="text-slate-500 mb-1" data-id="element-246">{t('certificate.certNo')}</p>
                <p className="font-semibold text-slate-900" data-id="element-247">
                  {ownerData.certificateNo}
                </p>
              </div>
              <div data-id="element-248">
                <p className="text-slate-500 mb-1" data-id="element-249">Total Lands</p>
                <p className="font-semibold text-slate-900" data-id="element-250">
                  {lands.length} properties
                </p>
              </div>
              <div data-id="element-251">
                <p className="text-slate-500 mb-1" data-id="element-252">Last Verified</p>
                <p className="font-semibold text-slate-900" data-id="element-253">Just now</p>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </div>;
}